'use client';

import React from 'react';
import { RevshareCost } from '../types';

interface CommentCellProps {
  cost: RevshareCost;
}

const CommentCell: React.FC<CommentCellProps> = ({ cost }) => {
  if (!cost.description) {
    return <div className="text-neutral-500 text-sm">-</div>;
  }

  return (
    <div className="flex max-w-[16.875rem]">
      <p className="text-auth-muted text-sm font-normal break-all leading-[1.125rem] ">
        {cost.description}
      </p>
    </div>
  );
};

export default CommentCell;
